/**
 * useTypography — returns the canonical (primary) type scale.
 *
 * Typography is theme-invariant, so this simply returns the TYPOGRAPHY constant.
 * The hook exists for a consistent API alongside useThemeColors/useSpacing/etc.,
 * and gives us a single seam if typography ever becomes theme-aware.
 *
 * @example
 * const type = useTypography();
 * <Text style={type.heading1}>{title}</Text>
 */
import { TYPOGRAPHY } from '@/constants/shared/theme/typography';
import type { Typography } from '@/constants/shared/theme';

export function useTypography(): Typography {
  return TYPOGRAPHY;
}
